import { configureEcho } from '@laravel/echo-vue';
import { currentUserToken } from '@/composables/auth';
import { computed, watchEffect } from 'vue';

type EchoOptions = Parameters<typeof configureEcho>[0];
const echoConfig: EchoOptions = computed(() => {
    let baseConfig: EchoOptions = {
        broadcaster: 'ably',
        key: import.meta.env.VITE_ABLY_PUBLIC_KEY,
    };

    if (currentUserToken.value) {
        baseConfig = {
            ...baseConfig,
            authEndpoint: `${import.meta.env.VITE_APP_URL}/api/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: `Bearer ${currentUserToken.value}`,
                },
            },
        };
    }

    return baseConfig;
});

watchEffect(() => {
    configureEcho(echoConfig.value);
});
